import { normalizeDateOfBirth } from '../../lib/helpers/helperFunctions'
import { ROUTES } from '../../lib/routes'
import { ClientDetailsFormValues, REFERRAL_LINK_PAGE_PARAMS } from './constants'

export function referralLinkRoute(code: string) {
  return ROUTES.referralLink.replace(`:${REFERRAL_LINK_PAGE_PARAMS.code}`, code)
}

export function normalizeClientDetailsValues(
  values: ClientDetailsFormValues,
): ClientDetailsFormValues {
  return {
    ...values,
    dateOfBirth: hasProvidedDateOfBirth(values.dateOfBirth)
      ? normalizeDateOfBirth(values.dateOfBirth)
      : undefined,
  }
}

export function hasProvidedDateOfBirth(
  dateOfBirth?: string,
): dateOfBirth is string {
  return !!dateOfBirth && !!dateOfBirth.replaceAll('/', '').trim()
}
